import { Component, Inject } from '@angular/core';
// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { LatestUpdate } from '@cigna/chcp/dashboard/data-access';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'cigna-new-features-dialog',
  templateUrl: './new-features-dialog.component.html',
  styleUrls: ['./new-features-dialog.component.scss'],
})
export class NewFeaturesDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NewFeaturesDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      feature: LatestUpdate;
    },
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
